// src/config.js
export const API_BASE_URL = "https://d69itwkdojaax.cloudfront.net"; // NO trailing slash

export const getCategoriesUrl = () => `${API_BASE_URL}/categories.json`;
export const getHashtagUrl = (tag) =>
  `${API_BASE_URL}/HASHTAGS/${encodeURIComponent(tag)}.json`;
 
export const getNewsPageUrl = (category, page = "start.json") => {
 
  if (page.startsWith("http://") || page.startsWith("https://")) {
    return page;
  }
  return `${API_BASE_URL}/${category}/${page}`;
};

 
export const getStoryUrl = (slug) => `${API_BASE_URL}/stories/${slug}.json`;

// image bases
export const THUMB_BASE_URL = `${API_BASE_URL}/images/thumbs/`;
export const IMAGE_BASE_URL = `${API_BASE_URL}/images/`;

// ✅ ADD this: last-updated location
// change the filename/path if yours is different
export const getLastUpdatedUrl = () => `${API_BASE_URL}/lastUpdated.json`;
